import { render, staticRenderFns } from "./GritifyLogo.vue?vue&type=template&id=0ae8889b&scoped=true&"
import script from "./GritifyLogo.vue?vue&type=script&lang=ts&"
export * from "./GritifyLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae8889b",
  null
  
)

export default component.exports